import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Subrecipients',
      type: 'table',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'sr.save-subrecipient',
            },
          },
          {
            '{}': {
              alias: 'sr.actions.delete-subrecipient',
            },
          },
        ],
      },
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'subrecipients',
                },
              },
              subqueries: {
                subrecipients: {
                  target: 'ent:!subrecips:!subrecip',
                },
              },
            },
          },
          query: {
            '`': {
              target: 'ent:!subrecips:!subrecip',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      website: {
                        '{}': {
                          value: {
                            '@.': '!website',
                          },
                        },
                      },
                      description: {
                        '{}': {
                          value: {
                            '@.': '!descr',
                          },
                        },
                      },
                      institution: {
                        '{}': {
                          value: {
                            '@': 'institutions',
                          },
                        },
                      },
                      primaryContact: {
                        '{}': {
                          value: {
                            '@.': '!primary_contact',
                          },
                        },
                      },
                    },
                  },
                  onEdit: {
                    '{}': {
                      action: {
                        '{}': {
                          payload: {
                            '{}': {
                              widget: {
                                '{}': {
                                  alias:
                                    'sr.subrecipients.widgets.edit-subrecipients',
                                },
                              },
                              variables: {
                                '{}': {
                                  subrecipientId: {
                                    '@.': '!id',
                                  },
                                },
                              },
                            },
                          },
                          operation: 'ui.modal',
                        },
                      },
                    },
                  },
                  onClick: {
                    '{}': {
                      action: {
                        '{}': {
                          payload: {
                            '{}': {
                              goto: {
                                '{}': {
                                  variables: {
                                    '{}': {
                                      subrecipientId: {
                                        '@.': '!id',
                                      },
                                    },
                                  },
                                  navigationId: 'subrecipient-details',
                                },
                              },
                            },
                          },
                          operation: 'ui.navigate',
                        },
                      },
                    },
                  },
                  onDelete: {
                    '{}': {
                      action: {
                        '{}': {
                          alias: 'sr.actions.delete-subrecipient',
                        },
                      },
                      confirm: {
                        '{}': {
                          title: 'Delete subrecipient',
                          message: 'Are you sure?',
                        },
                      },
                      variables: {
                        '{}': {
                          subrecipientId: {
                            '@.': '!id',
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                institutions: {
                  ref: {
                    attr: 'attr:ent#!subrecips#!subrecip:!institution',
                  },
                  target: 'ent:!ext_institutions:!institution',
                  selection: {
                    '@.': '!name',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!subrecips#!subrecip:!code',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'name',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!subrecips#!subrecip:!name',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'description',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!subrecips#!subrecip:!descr',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'website',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!subrecips#!subrecip:!website',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'primaryContact',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!subrecips#!subrecip:!primary_contact',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'institution',
                  direct: {
                    '{}': {
                      name: 'Institution',
                      type: 'TEXT',
                    },
                  },
                },
              },
            ],
          },
          onCreate: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias: 'sr.subrecipients.widgets.edit-subrecipients',
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        },
      },
    },
  },
}
